var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("商城管理")]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { name: "mallOrderList" } } },
                [_vm._v("商城订单")]
              ),
              _c("el-breadcrumb-item", [_vm._v("商城订单详情")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "hx-form-container box-shadow",
        },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: { model: _vm.listParams, "label-width": "140px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "用户账号：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.userAccount)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单号：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.orderNumber)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单状态：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.orderStatusDisplay)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "支付状态：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.payStatusDisplay)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "下单日期：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.listParams.orderDate,
                                true
                              )
                            )
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单总金额：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.orderAmount)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品数量：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.goodsNumber)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "供应商家：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.supplier)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "退款总金额：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.returnAmount)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-form-item", { attrs: { label: "收货地址：" } }, [
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(_vm._s(_vm.listParams.receiveAddress)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "hx-form-container box-shadow" }, [
        _c(
          "div",
          { staticClass: "pictures-display" },
          _vm._l(_vm.listParams.goodsPictures, function (item, index) {
            return _c("img", { key: index, attrs: { src: item, alt: "" } })
          }),
          0
        ),
      ]),
      _c(
        "hx-table-result",
        { attrs: { "show-pager-on-one-page": false, loading: false } },
        [
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.listParams.goodsList,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { prop: "goodName", align: "center", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "goodSpec", align: "center", label: "商品规格" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsNumber",
                  align: "center",
                  label: "购买数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "returnNumber",
                  align: "center",
                  label: "退货数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsAmount",
                  align: "center",
                  label: "商品总额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" ¥ " + _vm._s(scope.row.goodsAmount) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "returnAmount",
                  align: "center",
                  label: "退货总额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" ¥ " + _vm._s(scope.row.returnAmount) + " "),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            "text-align": "center",
            "margin-top": "10px",
          },
        },
        [
          _vm.listParams.orderStatusValue === 2
            ? _c(
                "el-button",
                {
                  staticStyle: { width: "120px" },
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deliverItem(_vm.orderId)
                    },
                  },
                },
                [_vm._v(" 发货 ")]
              )
            : _vm._e(),
          _vm.listParams.orderStatusValue === 3
            ? _c(
                "el-button",
                {
                  staticStyle: { width: "120px" },
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.receiveItem(_vm.orderId)
                    },
                  },
                },
                [_vm._v(" 收货 ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }